/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';

import { notaryAPI } from '../../../api/notary';
import { setUsers } from '../../../actions/signingRoomActions';
import { participantAPI } from '../../../api/participant';
import { useInterval } from '../../../hooks/useInterval';
import { useRootSelector } from '../../../hooks/useRootSelector';
import { isNotaryRoute } from '@utils/routing';
import { isEqual } from '@utils/lodash';

const USER_REFRESH_INTERVAL = 5000;

export const usePollUsers = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isNotary = isNotaryRoute(location.pathname);
  const { callDetails, signingRoom } = useRootSelector(state => state);

  const fetchAndSetUsers = async () => {
    if (!!callDetails?.id) {
      const userData = isNotary
        ? await notaryAPI.calls.fetchCallUserData(callDetails.id)
        : await participantAPI.calls.fetchCallUserData(callDetails.id);
      if (!isEqual(userData, signingRoom.users)) {
        setUsers(userData)(dispatch);
      }
    }
  };

  useInterval(fetchAndSetUsers, USER_REFRESH_INTERVAL);
};
